import { MediaItem } from '../types';

/**
 * Calculate insertion position for new media items
 */
export const calculateInsertionPosition = (
  prevItems: MediaItem[],
  shouldAddAtCurrentTime: boolean,
  currentTime: number,
  duration: number
): { start: number; end: number } => {
  const targetStart = shouldAddAtCurrentTime 
    ? currentTime 
    : (prevItems.length > 0 ? prevItems[prevItems.length - 1].end : 0);
    
  let start = targetStart;
  let end = targetStart + duration;

  if (shouldAddAtCurrentTime) {
    // Check for conflicts and find available space
    const hasConflict = prevItems.some(item => 
      (start >= item.start && start < item.end) ||
      (end > item.start && end <= item.end) ||
      (start <= item.start && end >= item.end)
    );

    console.log('🎯 Position conflict check:', { hasConflict, start, end });
  }

  return { start, end };
};

/**
 * Generate a unique ID for media items
 */
export const generateMediaItemId = (prefix: string = '', name: string = ''): string => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 10000);
  
  if (prefix) {
    return `${prefix}-${timestamp}-${random}`;
  }
  
  return `${timestamp}-${random}-${name}`;
};

/**
 * Create a new media item with proper defaults
 */
export const createMediaItem = (
  name: string,
  url: string,
  type: 'image' | 'video',
  start: number,
  end: number,
  options?: {
    src?: string;
    idPrefix?: string; // e.g., 'ai-generated', 'ai-video', 'uploaded'
    additionalProps?: Partial<MediaItem>; // For any extra properties
  }
): MediaItem => {
  const id = generateMediaItemId(options?.idPrefix || '', name);
  
  return {
    id,
    name,
    start,
    end,
    url,
    type,
    length: end - start,
    src: options?.src || url,
    ...options?.additionalProps, // Spread any additional properties
  };
};

/**
 * Sort media items by start time
 */
export const sortMediaItemsByStartTime = (items: MediaItem[]): MediaItem[] => {
  return [...items].sort((a, b) => a.start - b.start);
};